export interface ProgressState {
    error: boolean;
    errorMessage: string | undefined;
    running: boolean;
    done: boolean;
}

export const getInitialProgressState = (): ProgressState => {
    return { done: false, error: false, errorMessage: undefined, running: false };
};

export const done = (): ProgressState => ({
    done: true,
    error: false,
    errorMessage: undefined,
    running: false,
});
export const running = (): ProgressState => ({
    running: true,
    done: false,
    error: false,
    errorMessage: undefined,
});

export const error = (errorMessage?: string): ProgressState => ({
    error: true,
    errorMessage,
    done: false,
    running: false,
});
